const   objectionTrackActions = {
 
    GET_OBJECTION_TRACKER : 'GET_OBJECTION_TRACKER',
    SET_OBJECTION_TRACKER : 'SET_OBJECTION_TRACKER',

    GET_ANSWER_KEY : 'GET_ANSWER_KEY',
    SET_ANSWER_KEY : 'SET_ANSWER_KEY',

    GET_ROLL_NO : 'GET_ROLL_NO',
    SET_ROLL_NO : 'SET_ROLL_NO',


    GET_OBJECTION_COURSES : 'GET_OBJECTION_COURSES',
    SET_OBJECTION_COURSES : 'SET_OBJECTION_COURSES',

    RAISE_OBJECTION_DETAILS_CREATION: 'RAISE_OBJECTION_DETAILS_CREATION',

    GET_CANDIDATE_OBJECTION_DETAILS : 'GET_CANDIDATE_OBJECTION_DETAILS',
    SET_CANDIDATE_OBJECTION_DETAILS : 'SET_CANDIDATE_OBJECTION_DETAILS',


    GET_OBJECTION_DELETE : 'GET_OBJECTION_DELETE',
    SET_OBJECTION_DELETE : 'SET_OBJECTION_DELETE',


    RAISE_OBJECTION_BUTTON_CLICK : 'RAISE_OBJECTION_BUTTON_CLICK'



};

export default objectionTrackActions;